import React from 'react'

export const Footer = () => {
  return (
    <footer>
      <div className='container-fluid footer-container-fluid footerFont text-muted'>
        <br />
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='small'>
                <p>
                  Barnes &amp; Noble is an equal opportunity and affirmative
                  action employer.&nbsp; All qualified applicants will receive
                  consideration for employment without regard to age, race,
                  color, ancestry, national origin, citizenship status, military
                  or veteran status, religion, creed, disability, sex, sexual
                  orientation, marital status, medical condition as defined by
                  applicable law, genetic information, gender, gender identity,
                  gender expression (including transgender status), hairstyle,
                  height and/or weight, pregnancy, childbirth and
                  related medical conditions, reproductive health decisions, or
                  any other self-identified, perceived or actual characteristic protected by applicable federal,
                  state, or local laws and ordinances.
                </p>

                <p>
                  Please tell us if you require a reasonable accommodation to
                  apply for a job or to perform your job.&nbsp; Examples of
                  reasonable accommodation include making a change to the
                  application process or work procedures, providing documents in
                  an alternate format, using a sign language interpreter, or
                  using specialized equipment.&nbsp; Contact (800) 799-5335.
                </p>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='sfContentBlock small'>
                <p>
                  <a
                    className='text-dark font-weight-bold'
                    href='http://www.barnesandnoble.com/h/help/about/terms-of-use'
                  >
                    Terms of Use
                  </a>
                  , Copyright, and{' '}
                  <a
                    className='text-dark font-weight-bold'
                    href='http://www.barnesandnoble.com/h/help/privacy-policy'
                  >
                    Privacy Policy
                  </a>
                  &nbsp; © 1997-{new Date().getFullYear()} Barnes &amp; Noble
                  Booksellers, Inc. 33 East 17th Street, New York, NY 10003
                </p>
              </div>
              <hr />
            </div>
          </div>
        </div>

        <div className='container-fluid'>
          <div className='container'>
            <div className='row '>
              <div className='col-lg-12 text-center'>
                <small>
                  <a href='/rss' className='text-dark'>
                    RSS Feed
                  </a>
                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                  <a
                    href='https://www.barnesandnobleinc.com/'
                    className='text-dark'
                  >
                    Corporate Site
                  </a>
                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                  <a
                    href='https://www.barnesandnoble.com/'
                    className='text-dark'
                  >
                    BN.com
                  </a>
                </small>
              </div>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
